import { render } from "./ChangeCategoryField.vue?vue&type=template&id=07ff444e"
import script from "./ChangeCategoryField.vue?vue&type=script&lang=js"
export * from "./ChangeCategoryField.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__